export class GahGroups {
  gahGroupsMap: { [key: string]: string } = {};
  accountCodeMap: { [key: string]: string } = {};
  gahEvents: string[] = ["share_event","page_view","cart_event","download_event","login_event","click_event"];
  constructor() {
    this.gahGroupsMap = {
      E: "Exhibitor Relations",
      P: "Publicity",
      VR: "Virtual Reality",
    };

    this.accountCodeMap = {
      "Exhibitor" : "E",
      "Publicity" : "P",
      "Virtual Reality" : "VR"
    };
  }
}